import { oc } from '@orpc/contract';
import { directionInputSchema, directionOutputSchema } from '../schemas/board.schemas.js';
export const getDirectionContract = oc
    .route({
    method: 'GET',
    path: '/board/direction',
    tags: ['Board'],
    summary: 'The three Ages with their gates, units and revenue to date, the last-4-weeks run-rate and % of gate (every role)',
})
    .input(directionInputSchema)
    .output(directionOutputSchema);
//# sourceMappingURL=get-direction.contract.js.map